// extracted by mini-css-extract-plugin
export var highlightFade = "_2v-4";
export var highlighted = "_2v-3";
export var table = "_2v-1";
export var tableContainer = "_2v-0";
export var totalsRow = "_2v-2";